// extracted by mini-css-extract-plugin
export default {"limit":"Limit_limit__ebDZj"};